import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 15,
		stroke: "#CCCFD8",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 16.8889L15.3333 20L20 13",
		stroke: "#BEBEC1",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgYesIcon;
